import { render, staticRenderFns } from "./SettingsLegal.vue?vue&type=template&id=517bb126&"
import script from "./SettingsLegal.vue?vue&type=script&lang=js&"
export * from "./SettingsLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports